import ApiService from '../../services/api.service';

export default {
  namespaced: true,
  state: {
    isLoading: true,
    bcAssessment: {},
    defaultAssessment: {
      q1: null,
      q2: null,
      q3: null,
      q4: null,
      q5: null,
      q6: null,
      q7: false,
      q8: false,
      q9: null,
      q10: null,
    },
  },

  mutations: {
    SET_ASSESSMENT(state, value) {
      state.bcAssessment = value;
    },
    RESET_ASSESSMENT(state) {
      state.bcAssessment = { ...state.defaultAssessment };
    },
    NOT_ABLE_CONTACT(state) {
      const currentQ8 = state.bcAssessment.q8;

      state.bcAssessment = {
        ...state.defaultAssessment,
        q8: currentQ8,
      };
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    setQ9(state, value) {
      state.bcAssessment.q9 = value === true || value === 'true';
    },
  },

  actions: {
    async checkExistingAssessment({ commit }, currentDealership) {
      commit('SET_LOADING', true);

      let params = {
        'q[dealer_id_eq]': currentDealership.id,
        'q[s]': 'created_at desc',
      };

      await ApiService.query('bay_count_assessments', { params }).then(
        (response) => {
          if (response.data && response.data.length > 0) {
            commit('SET_ASSESSMENT', response.data[0]);
          } else {
            commit('RESET_ASSESSMENT', null);
          }
          commit('SET_LOADING', false);
        }
      );
    },

    async submitAssessment({ state, dispatch }, currentDealership) {
      // Check if we have an existing assessment we can update
      if (state.bcAssessment.id) {
        await ApiService.update(
          `bay_count_assessments`,
          state.bcAssessment.id,
          {
            bay_count_assessment: state.bcAssessment,
          }
        ).then(() => {
          dispatch('checkExistingAssessment', currentDealership);
        });
      } else {
        // Create new assessment
        let params = state.bcAssessment;
        params.dealer_id = currentDealership.id;

        await ApiService.post('bay_count_assessments', {
          bay_count_assessment: params,
        }).then(() => {
          dispatch('checkExistingAssessment', currentDealership);
        });
      }

      return state.bcAssessment;
    },
  },
};
